import React from 'react';
import OnboardingGuideModal from '../OnboardingGuideModals/OnboardingGuideModal.react';
import {PropTypes} from 'prop-types';
import LocaleContext from '../../../../Contexts/Locale/Context';
import './OnboardingGuide.less';
import {ONBOARDING_COMPLETE_KEY} from '../../../../constants';

// eslint-disable-next-line no-lone-blocks
{
    /* images*/
}
import HandIcon from './hand_icon.svg';
import HotSpotIcon from './hot_spot_icon.svg';
import ListIcon from './list_icon.svg';

class OnboardingGuide extends React.PureComponent {
    static propTypes = {
        pageIndex: PropTypes.number.isRequired,
        pages: PropTypes.arrayOf(
            PropTypes.shape({
                textKey: PropTypes.string.isRequired,
                nextKey: PropTypes.string,
                doneKey: PropTypes.string,
                transition: PropTypes.string.isRequired,
                icon: PropTypes.string,
                iconAnimationClass: PropTypes.string,
            })
        ),
        onDone: PropTypes.func,
        onPage: PropTypes.func,
    };

    static defaultProps = {
        pages: [
            {
                textKey: 'onboarding.dragHint',
                nextKey: 'onboarding.next',
                doneKey: 'onboarding.skip',
                transition: 'fade',
                icon: HandIcon,
                iconAnimationClass: 'OnboardingIcon1',
                index: 0,
            },
            {
                textKey: 'onboarding.selectHint',
                doneKey: 'onboarding.closeButton',
                transition: 'fadeDelay',
                icon: HotSpotIcon,
                iconAnimationClass: 'OnboardingIcon2',
                index: 1,
            },
        ],
    };

    static noHotspotProps = {
        pages: [
            {
                textKey: 'onboarding.dragHint',
                nextKey: 'onboarding.next',
                doneKey: 'onboarding.skip',
                transition: 'fade',
                icon: HandIcon,
                iconAnimationClass: 'OnboardingIcon1',
                index: 0,
            },
            {
                textKey: 'onboarding.directNavOnly',
                doneKey: 'onboarding.closeButton',
                transition: 'fadeDelay',
                icon: ListIcon,
                iconAnimationClass: 'OnboardingIcon3',
                index: 1,
            },
        ],
    };

    static getDerivedStateFromProps(nextProps, previousState) {
        return {
            page: nextProps.pages[nextProps.pageIndex],
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            page: null,
        };
    }

    _onDone = (buttonClicked: boolean, buttonName: string) => {
        try {
            localStorage.setItem(ONBOARDING_COMPLETE_KEY, true);
        } catch (err) {
            console.log('Could not access localStorage. Cookies might be disabled.');
        }
        if (this.props.onDone) {
            this.props.onDone(!buttonClicked, buttonName);
        }
    };

    _onNext = (buttonClicked: boolean, buttonName: string) => {
        if (this.props.onPage) {
            this.props.onPage(!buttonClicked, buttonName, this.props.pageIndex);
        }
    };

    render() {
        let page = this.state.page;
        let pages = this.props.pages;

        return (
            <LocaleContext.Consumer>
                {(getTranslation) => (
                    <div className="OnboardingGuideContainer">
                        {[
                            page ? (
                                <OnboardingGuideModal
                                    key={page.index}
                                    text={getTranslation('messages', page.textKey)}
                                    page={`${page.index + 1}/${pages.length}`}
                                    next={
                                        page.nextKey
                                            ? getTranslation('messages', page.nextKey)
                                            : null
                                    }
                                    done={
                                        page.doneKey
                                            ? getTranslation('messages', page.doneKey)
                                            : null
                                    }
                                    transition={page.transition}
                                    icon={page.icon}
                                    iconAnimationClass={page.iconAnimationClass}
                                    index={page.index}
                                    onDone={this._onDone}
                                    onNext={this._onNext}
                                />
                            ) : null,
                        ]}
                    </div>
                )}
            </LocaleContext.Consumer>
        );
    }
}

export default OnboardingGuide;
